import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { computed } from 'vue';
import {
  inputDehydrationDefinitions,
  isFirma,
} from '@/features/Sparten/shared/inputDehydration/kfz/campKrad/inputDehydration';
import {
  isNoSaisonKennzeichen,
  isNoSaisonkennzeichen,
} from '@/features/Sparten/shared/inputDehydration/kfz/conditionalRequestDefinitions';
import { isWkz127 } from '@/features/Sparten/campv2/renderConditions';
import { hasLeistung } from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';

/**
 * Firma-Droplist: wie die shared camp-/krad-Regel, plus die drei V2-Personenfelder.
 * Der Backend-Validator erlaubt VN-Personenfelder nur für Nicht-Firmen.
 */
const isFirmaWithV2Fields: ConditionalRequestDefinition = {
  ...isFirma,
  drop: [
    ...isFirma.drop,
    'versicherungsnehmer.anSicherheitstrainingTeilnahmedatum',
  ],
};

/**
 * Hersteller ist nur bei Wohnmobil (WKZ 127) sichtbar; bei anderem Wagnis nicht senden —
 * das Feld wird sonst nur ausgeblendet und behielte seinen zuvor gewählten Wert.
 */
const isNichtWohnmobil: ConditionalRequestDefinition = {
  if: computed(() => !isWkz127.value),
  drop: ['fahrzeug.hersteller'],
};

/**
 * Motorleistung ist nur bei WKZ mit Antrieb sichtbar (Wohnmobil 127, nicht Anhänger 541);
 * bei ausgeblendetem Feld den zuvor gewählten kW-Wert nicht senden. Konvention wie die
 * shared `is*Available`-Regeln.
 */
const isLeistungAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasLeistung.value),
  drop: ['fahrzeug.leistung'],
};

/**
 * Input-Dehydration für campv2: übernimmt die shared camp-/krad-Liste und ersetzt nur die
 * Saisonkennzeichen- und Firma-Regel durch die V2-Varianten, plus die Hersteller- und
 * Leistungs-Regel.
 */
export const campv2InputDehydrationDefinitions: ConditionalRequestDefinition[] =
  [
    ...inputDehydrationDefinitions.map((definition) => {
      if (definition === isNoSaisonkennzeichen) {
        return isNoSaisonKennzeichen;
      }

      if (definition === isFirma) {
        return isFirmaWithV2Fields;
      }

      return definition;
    }),
    isNichtWohnmobil,
    isLeistungAvailable,
  ];
